(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-spitfire-presell"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-spitfire-presell]').forEach((root) => {
    if (root.dataset.selectorReady === 'true') return;
    root.dataset.selectorReady = 'true';
    const choices = root.querySelectorAll('[data-model-choice]');
    const cards = root.querySelectorAll('[data-model-card]');
    const status = root.querySelector('[data-selection-status]');
    choices.forEach((choice) => {
      choice.addEventListener('change', () => {
        cards.forEach((card) => card.classList.toggle('is-selected', card.dataset.modelCard === choice.dataset.card));
        if (status) status.textContent = choice.dataset.announcement;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsc-buybox"] && !Shopify.designMode) return;
  try {
    
  const initializeWscBuybox = (root) => {
    if (!root || root.dataset.wscReady === 'true') return;
    root.dataset.wscReady = 'true';

    const mediaItems = Array.from(root.querySelectorAll('[data-wsc-media]'));
    const thumbs = Array.from(root.querySelectorAll('[data-wsc-thumb]'));
    const previousMedia = root.querySelector('[data-wsc-gallery-previous]');
    const nextMedia = root.querySelector('[data-wsc-gallery-next]');

    const activateMedia = (mediaId) => {
      mediaItems.forEach((item) => {
        const isActive = item.dataset.wscMedia === mediaId;
        item.hidden = !isActive;
        if (!isActive) item.querySelector('video')?.pause();
      });

      thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.wscThumb === mediaId;
        thumb.setAttribute('aria-selected', String(isActive));
        if (isActive) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    };

    const moveMedia = (offset) => {
      if (mediaItems.length < 2) return;
      const activeIndex = Math.max(0, mediaItems.findIndex((item) => !item.hidden));
      const nextIndex = (activeIndex + offset + mediaItems.length) % mediaItems.length;
      activateMedia(mediaItems[nextIndex].dataset.wscMedia);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activateMedia(thumb.dataset.wscThumb));
    });

    previousMedia?.addEventListener('click', () => moveMedia(-1));
    nextMedia?.addEventListener('click', () => moveMedia(1));

    const selector = root.querySelector('[data-wsc-variant]');
    const price = root.querySelector('[data-wsc-current-price]');
    const compare = root.querySelector('[data-wsc-current-compare]');
    const submit = root.querySelector('[data-wsc-submit]');
    const submitText = root.querySelector('[data-wsc-submit-text]');
    const stickyPrice = root.querySelector('[data-wsc-sticky-price]');
    const stickySubmit = root.querySelector('[data-wsc-sticky-submit]');
    const stickyScroll = root.querySelector('[data-wsc-sticky-scroll]');
    const form = root.querySelector('[data-wsc-product-form]');

    const updateVariant = () => {
      if (!selector) return;
      const option = selector.options[selector.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
      }
      if (submit) submit.disabled = !available;
      if (stickySubmit) stickySubmit.disabled = !available;
      if (submitText) submitText.textContent = available ? submit.dataset.availableText : submit.dataset.soldOutText;
    };

    if (submit && submitText) {
      submit.dataset.availableText = submitText.textContent.trim();
      submit.dataset.soldOutText = selector?.selectedOptions[0]?.textContent.includes('·')
        ? selector.selectedOptions[0].textContent.split('·').pop().trim()
        : 'Sold out';
    }

    selector?.addEventListener('change', updateVariant);
    stickySubmit?.addEventListener('click', () => form?.requestSubmit());
    stickyScroll?.addEventListener('click', () => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      (form || root).scrollIntoView({ behavior, block: 'start' });
    });

    const ugcVideoTriggers = root.querySelectorAll('[data-wsc-ugc-video]');

    ugcVideoTriggers.forEach((trigger) => {
      const video = trigger.querySelector('video');
      if (!video) return;

      const setPlayingState = (isPlaying) => {
        trigger.classList.toggle('is-playing', isPlaying);
        trigger.setAttribute('aria-pressed', String(isPlaying));
      };

      trigger.addEventListener('click', () => {
        const shouldPlay = video.paused;

        ugcVideoTriggers.forEach((otherTrigger) => {
          if (otherTrigger === trigger) return;
          otherTrigger.querySelector('video')?.pause();
        });

        if (shouldPlay) {
          video.play().catch(() => setPlayingState(false));
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', () => setPlayingState(true));
      video.addEventListener('pause', () => setPlayingState(false));
      video.addEventListener('ended', () => setPlayingState(false));
    });

    const sticky = root.querySelector('[data-wsc-sticky]');
    if (sticky && submit) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0 });
      observer.observe(submit);
    }
  };

  document.querySelectorAll('[data-wsc-buy]').forEach(initializeWscBuybox);
  document.addEventListener('shopify:section:load', (event) => initializeWscBuybox(event.target.querySelector('[data-wsc-buy]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wsc-pdp-nav"] && !Shopify.designMode) return;
  try {
    
  const initializeWscPdpNav = (nav) => {
    if (!nav || nav.dataset.wscPdpNavReady === 'true') return;
    nav.dataset.wscPdpNavReady = 'true';

    const stickySection = nav.closest('.shopify-section');
    const links = Array.from(nav.querySelectorAll('[data-wsc-pdp-nav-link]'));
    const items = links
      .map((link) => ({ link, target: document.querySelector(link.hash) }))
      .filter((item) => item.target);

    if (!stickySection || items.length === 0) return;

    let activeLink = null;
    let updateFrame = null;

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const getOffset = () => {
      const stickyTop = Number.parseFloat(window.getComputedStyle(stickySection).top) || 0;
      return stickyTop + stickySection.offsetHeight;
    };

    const setActive = (link) => {
      if (!link || activeLink === link) return;
      activeLink = link;
      links.forEach((itemLink) => {
        if (itemLink === link) {
          itemLink.setAttribute('aria-current', 'location');
        } else {
          itemLink.removeAttribute('aria-current');
        }
      });
      link.scrollIntoView({
        behavior: reducedMotion() ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    };

    const updateActive = () => {
      updateFrame = null;
      const marker = window.scrollY + getOffset() + 24;
      let current = items[0];

      items.forEach((item) => {
        const targetTop = item.target.getBoundingClientRect().top + window.scrollY;
        if (targetTop <= marker) current = item;
      });

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        current = items[items.length - 1];
      }

      setActive(current.link);
    };

    const requestUpdate = () => {
      if (updateFrame) return;
      updateFrame = window.requestAnimationFrame(updateActive);
    };

    items.forEach(({ link, target }) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getOffset() + 1;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: reducedMotion() ? 'auto' : 'smooth'
        });
        window.history.replaceState(null, '', link.hash);
        setActive(link);
      });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('theme:resize', requestUpdate);
    requestUpdate();
  };

  document.querySelectorAll('[data-wsc-pdp-nav]').forEach(initializeWscPdpNav);
  document.addEventListener('shopify:section:load', (event) => {
    initializeWscPdpNav(event.target.querySelector('[data-wsc-pdp-nav]'));
  });

  } catch(e) { console.error(e); }
})();
})();
